import script from "./ClearmentLsk.vue?vue&type=script&setup=true&lang=js"
export * from "./ClearmentLsk.vue?vue&type=script&setup=true&lang=js"

import "./ClearmentLsk.vue?vue&type=style&index=0&id=27dcedf4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27dcedf4"]])

export default __exports__